import { FlexComponentBootstrap } from '../../../common/component-bootstraper';
import HearingTestInvitationApp from './react-hearing-test-invitation';
import { FLEX_LAYOUT_CLASS_NAME } from '../../../common/consts';
var componentName = 'hearing-test-invitation';
var flexHearingTestInvitation = new FlexComponentBootstrap(componentName, FLEX_LAYOUT_CLASS_NAME);
flexHearingTestInvitation.reactApp = HearingTestInvitationApp;
flexHearingTestInvitation.run();